import { CloseIcon, PremiumIcon } from "assets/icons";
import Button from "components/BaseWidgets/button";
import premiumImage from "assets/images/png/go-premium-profile.png";
import "./style.scss";
import { useState } from "react";

function PremiumCard({ showCard = true }) {
  const [card, setCard] = useState(true);
  return (
    <div className="engage-premium-card outer">
      {card && showCard && (
        <div className="flex flex-col gap-8 justify-end inner-card">
          <Button
            onClick={() => setCard(false)}
            className="close-btn"
            variant="custom"
          >
            <CloseIcon />
          </Button>
          <div className="flex flex-col gap-2 justify-center">
            <span className="image">
              <img src={premiumImage} alt="" />
            </span>
            <p className="description">To unlock more features</p>
          </div>
          <Button href="/plans" wFull icon={<PremiumIcon />} variant="primary">
            Go premium now
          </Button>
        </div>
      )}
    </div>
  );
}

export default PremiumCard;
